export default {
  settings: {
    zh: '设置',
    en: 'Settings',
    ja: '設定',
  },
  general: {
    zh: '基础',
    en: 'General',
    ja: '一般',
  },
  language: {
    zh: '语言',
    en: 'Language',
    ja: '言語',
  },
  automatically: {
    zh: '自动检查更新',
    en: 'Auto check update',
    ja: '自動更新チェック',
  },
  maxReconnectTimes: {
    zh: '最大重连次数',
    en: 'Max reconnection times',
    ja: '最大再接続回数',
  },
  appearance: {
    zh: '外观',
    en: 'Appearance',
    ja: '外観',
  },
  theme: {
    zh: '主题',
    en: 'Theme',
    ja: 'テーマ',
  },
  light: {
    zh: '浅色',
    en: 'Light',
    ja: 'ライト',
  },
  dark: {
    zh: '深色',
    en: 'Dark',
    ja: 'ダーク',
  },
  advanced: {
    zh: '高级',
    en: 'Advanced',
    ja: '詳細',
  },
}
